import { css } from '@emotion/css';

export const dividerStyles = css`
  cursor: pointer;

  &.ProseMirror-selectednode.divider {
    background: #f2f2f2;
    transition: background 200ms ease-in-out;
    border-radius: 4px;
  }

  .Prosemirror-Readonly &.divider {
    cursor: default;
  }
`;
